// Generated by purs version 0.15.4
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as PartyCarlo_Data_Display from "../PartyCarlo.Data.Display/index.js";
import * as PartyCarlo_Utils from "../PartyCarlo.Utils/index.js";
var genericShowArgsArgument = /* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString);
var displayTrunc = /* #__PURE__ */ PartyCarlo_Utils.displayTrunc(PartyCarlo_Data_Display.displayString);
var InvalidNumber = /* #__PURE__ */ (function () {
    function InvalidNumber(value0) {
        this.value0 = value0;
    };
    InvalidNumber.create = function (value0) {
        return new InvalidNumber(value0);
    };
    return InvalidNumber;
})();
var InvalidProbability = /* #__PURE__ */ (function () {
    function InvalidProbability(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InvalidProbability.create = function (value0) {
        return function (value1) {
            return new InvalidProbability(value0, value1);
        };
    };
    return InvalidProbability;
})();
var ExperimentsFailed = /* #__PURE__ */ (function () {
    function ExperimentsFailed() {

    };
    ExperimentsFailed.value = new ExperimentsFailed();
    return ExperimentsFailed;
})();
var genericError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new InvalidNumber(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new InvalidProbability(x.value0.value0.value0, x.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return ExperimentsFailed.value;
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Error (line 19, column 1 - line 19, column 48): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof InvalidNumber) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof InvalidProbability) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)));
        };
        if (x instanceof ExperimentsFailed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Error (line 19, column 1 - line 19, column 48): " + [ x.constructor.name ]);
    }
};
var showError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(genericShowArgsArgument)({
        reflectSymbol: function () {
            return "InvalidNumber";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(genericShowArgsArgument)(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showNumber)))({
        reflectSymbol: function () {
            return "InvalidProbability";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ExperimentsFailed";
        }
    }))))
};
var eqError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof InvalidNumber && y instanceof InvalidNumber) {
                return x.value0 === y.value0;
            };
            if (x instanceof InvalidProbability && y instanceof InvalidProbability) {
                return x.value0 === y.value0 && x.value1 === y.value1;
            };
            if (x instanceof ExperimentsFailed && y instanceof ExperimentsFailed) {
                return true;
            };
            return false;
        };
    }
};
var displayError = {
    display: function (v) {
        if (v instanceof InvalidNumber) {
            return "\"" + (displayTrunc(13)(v.value0) + ("\"" + " is not a number"));
        };
        if (v instanceof InvalidProbability) {
            return displayTrunc(13)(v.value0) + " is not a probability (between 0 and 1)";
        };
        if (v instanceof ExperimentsFailed) {
            return "experiments failed to run. copy your data, reload the page, and try again.";
        };
        throw new Error("Failed pattern match at PartyCarlo.Pages.Home.Error (line 25, column 1 - line 28, column 109): " + [ v.constructor.name ]);
    }
};
export {
    InvalidNumber,
    InvalidProbability,
    ExperimentsFailed,
    eqError,
    genericError,
    showError,
    displayError
};
